import { Carousel as AntCarousel } from "antd";
import { useEffect, useState } from "react";
import styled from "styled-components";

interface StyledCarouselProps {
  style?: any;
}

export interface ICarousel {
  style?: any;
  images: any;
  imagesMobile: Array<string>;
}

const StyledCarousel = styled.div<StyledCarouselProps>``;

const isMobile = window.matchMedia(
  "only screen and (max-width: 760px)"
).matches;

const Carousel = ({ style, images, imagesMobile }: ICarousel) => {
  const [imagesForUse, setImagesForUse] = useState(images);

  useEffect(() => {
    if (imagesMobile.length > 0 && isMobile) {
      const newImages = imagesMobile
        .filter((image: any) => image.mobile_url)
        .map((image: any) => image.mobile_url);
      setImagesForUse(newImages);
    } else {
      const newImages = images
        .filter((image: any) => image.desktop_url)
        .map((image: any) => image.desktop_url);
      setImagesForUse(newImages);
    }
  }, [images, imagesMobile]);
  return (
    <StyledCarousel style={{ ...style }}>
      <AntCarousel autoplay dots={true}>
        {imagesForUse.map((i: any) => (
          <div
            key={i}
            style={{
              display: "flex !important",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              alt="image_carousel"
              src={i}
              style={{ width: "100%" }}
            />
          </div>
        ))}
      </AntCarousel>
    </StyledCarousel>
  );
};

export default Carousel;
